module.exports = __webpack_public_path__ + "img/16.53791c90.jpg";